import type { ReactNode } from "react";
import { useAuth } from "../hooks/use-auth";
import { LoadingIndicator } from "./LoadingIndicator";

type AuthGuardProps = { children: ReactNode };

/**
 * 認証ガード — 未認証ユーザーには Google ログインボタンを表示する。
 *
 * VITE_STAGE === "local" の場合は完全バイパス（API 側も同様にモックユーザーを使う）。
 */
export const AuthGuard = ({ children }: AuthGuardProps) => {
  // Hooks は条件分岐の前に呼ぶ（Rules of Hooks）
  const { authenticated, loading, login } = useAuth();

  // ローカル開発時はバイパス（VITE_STAGE はビルド時定数）
  if (import.meta.env.VITE_STAGE === "local") {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingIndicator label="読み込み中..." />
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4 px-4">
        <h1 className="text-2xl font-bold tracking-tight">lexivision</h1>
        <p className="text-sm text-neutral-600 text-center">
          語彙を視覚で補完する学習サポート
        </p>
        <button
          type="button"
          onClick={login}
          className="rounded-xl bg-neutral-900 px-6 py-3 text-white font-semibold hover:bg-neutral-700 transition-colors"
        >
          Google でログイン
        </button>
      </div>
    );
  }

  return <>{children}</>;
};
